(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gz-review-stars"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.documentElement;
    root.classList.add('gz-stars-ok');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var observer = null;

    function play(el) {
      el.setAttribute('data-gz-state', 'play');
    }

    function scan(scope) {
      var rows = (scope || document).querySelectorAll('[data-gz-stars]:not([data-gz-state])');
      if (!rows.length) return;
      if (reduce.matches || !('IntersectionObserver' in window)) {
        Array.prototype.forEach.call(rows, play);
        return;
      }
      if (!observer) {
        observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              play(entry.target);
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.6 });
      }
      Array.prototype.forEach.call(rows, function (row) { observer.observe(row); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { scan(); });
    } else {
      scan();
    }
    document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  })();
  } catch(e) { console.error(e); }
})();

})();
